import { render, staticRenderFns } from "./JdsWorkbenchBackButton.vue?vue&type=template&id=5b2f151e&scoped=true&"
import script from "./JdsWorkbenchBackButton.vue?vue&type=script&lang=ts&"
export * from "./JdsWorkbenchBackButton.vue?vue&type=script&lang=ts&"
import style0 from "./JdsWorkbenchBackButton.vue?vue&type=style&index=0&id=5b2f151e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2f151e",
  null
  
)

export default component.exports